<template>
<card :footer="true" :no-padding="true">
  <div class="is-relative" v-if="isNotHirer">
    <div v-if="widget" class="is-white">
      <widget-job-form v-if="!formSubmit" :actionButtonTooltip="applyTooltip"></widget-job-form>
    <widget-notification-message v-else :error="jobError"></widget-notification-message>
    </div>
    <div v-if="job.status !== 'published' && !job.applicationStatus" class="is-completed" v-tooltip="'This job has been filled'"></div>
    <div class="is-ghost rl-radius">
      <div class="field" v-if="isNotReferrer && !widget">
        <tooltip-button v-if="!job.applicationStatus" :tooltip="applyTooltip" @click="apply">
          {{this.$t('jobs.apply')}}
        </tooltip-button>
        <tooltip-button v-else-if="job.applicationStatus === 'offered'" v-tooltip="{content: tooltip, show: tooltipActive}"
        :tooltip="offerTooltip"
        @tooltipMouseover="tooltipActive=false" @tooltipMouseout="tooltipActive=true"
        @click="viewOffer">
          {{this.$t('jobs.viewOffer')}}
        </tooltip-button>
        <tooltip-button v-else-if="job.applicationStatus === 'hired'"
        :tooltip="acceptedTooltip" @click="accepted">
          {{this.$t('jobs.accepted')}}
        </tooltip-button>
        <tooltip-button v-else v-tooltip="{content: tooltip, show: tooltipActive}"
        :tooltip="applicationTooltip"
        @tooltipMouseover="tooltipActive=false" @tooltipMouseout="tooltipActive=true"
        @click="viewApplication">
          {{this.$t('jobs.viewApplication')}}
        </tooltip-button>
      </div>
      <div class="field">
        <tooltip-button :isInverted="true" :start="widget"
        :class="[job.status !== 'published' ? 'is-disabled': '']"
        :tooltip="refferTooltip" @click="refer">
        {{this.$t('widget.referSome')}}
        </tooltip-button>
      </div>
    </div>
  </div>
<template slot="footer" v-if="(isCompleted || jobViews >= 10 || appliedCounts >= 3) && !widget">
  <split-section>
    <template slot="left">
      <div class="has-text-centered" v-if="isCompleted">
        <h3 class="title is-3" v-if="job">{{ appliedCounts }}</h3>
        <h6 class="subtitle title is-7" v-if="job">{{ job.applications !== 1 ? this.$t('jobs.applicants') : this.$t('jobs.applicant') }}</h6>
      </div>
      <div class="has-text-centered" v-else>
        <h3 class="title is-3" v-if="job">{{ jobViews }}</h3>
        <h6 class="subtitle title is-7">{{this.$t('jobs.views')}}</h6>
      </div>
    </template>
    <template slot="right" v-if="isCompleted || jobViews >= 10 || appliedCounts >= 3">
      <div class="has-text-centered" v-if="isCompleted">
        <h3 class="title is-3" v-if="job">{{ hiredCount }}</h3>
        <h6 class="subtitle title is-7">{{this.$t('jobs.hired')}}</h6>
      </div>
      <div class="has-text-centered" v-else>
        <h3 class="title is-3" v-if="job">{{ appliedCounts }}</h3>
        <h6 class="subtitle title is-7" v-if="job">{{ job.applications !== 1 ? this.$t('jobs.applicants') : this.$t('jobs.applicant') }}</h6>
      </div>
    </template>
  </split-section>
</template>
</card>
</template>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex'
import TooltipButton from '../general/tooltip-button.vue'
import Card from '@/components/general/card'
import SplitSection from '@/components/general/split-section'
import RewardHelper from '@/helpers/reward'
import WidgetJobForm from '../widget/widget-job-form'
import WidgetNotificationMessage from '../widget/widget-notification-message'
import moment from 'moment'

export default {
  components: { Card, SplitSection, TooltipButton, WidgetJobForm, WidgetNotificationMessage },
  props: {
    job: {
      type: Object,
      default: () => null
    },
    appliedCounts: {
      type: String,
      default: ''
    },
    widget: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations('widget', ['setSelectedJobId', 'resetWidgetJobForm', 'setFormSubmit']),
    accepted () {
      this.$emit('accepted')
    },
    apply () {
      if (this.job.status === 'published') {
        this.$emit('apply')
      }
    },
    refer () {
      if (this.job.status === 'published') {
        this.$emit('refer')
      }
    },
    viewApplication () {
      this.$emit('viewApplication')
    },
    viewOffer () {
      this.$emit('viewOffer')
    },
    formatDate (value) {
      return moment(value).format('DD MMM YY')
    }
  },
  computed: {
    ...mapGetters('jobs', [
      'currentApplication',
      'currentOffer'
    ]),
    ...mapGetters('users', ['user']),
    ...mapState('widget', ['formSubmit', 'jobError']),
    ...mapState('jobs', [ 'currency', 'currentJobMin', 'currentJobMax', 'currentJobRewardPer', 'minCharity', 'maxCharity', 'charityRewardPer' ]),
    isNotReferrer () {
      if (!this.user) return true
      return this.user.profile !== 'referrer'
    },
    isNotHirer () {
      if (!this.user) return true
      return this.user.profile !== 'hirer'
    },
    userRewardPercentage () {
      if (this.percentage) {
        return this.percentage.user
      }
      return 0
    },
    getCharity () {
      if (this.minCharity || this.maxCharity) {
        if (this.minCharity && this.maxCharity) {
          return `${this.minCharity} - ${this.maxCharity}`
        } else if (this.minCharity) {
          return `${this.minCharity}`
        } else if (this.maxCharity) {
          return `${this.maxCharity}`
        }
      } else {
        return `${this.charityRewardPer ? this.charityRewardPer : 0}%`
      }
    },
    getReward () {
      if (this.currentJobMin || this.currentJobMax) {
        if (this.currentJobMin && this.currentJobMax) {
          return `${this.currentJobMin} - ${this.currentJobMax}`
        } else if (this.currentJobMin) {
          return `${this.currentJobMin}`
        } else if (this.currentJobMax) {
          return `${this.currentJobMax}`
        }
      } else {
        return `${this.currentJobRewardPer}%`
      }
    },
    acceptedTooltip () {
      return `Job accepted: ${this.formatDate(this.job.applicationUpdatedAt)}`
    },
    applicationTooltip () {
      return `Earn ${this.userRewardPercentage}% of the jobs pay and another 1% to donate to good causes`
    },
    applyTooltip () {
      return `To earn a ${this.getReward} of the jobs pay as well as ${this.getCharity} towards a charitable donation`
    },
    offerTooltip () {
      return `Earn ${this.userRewardPercentage}% of the jobs pay and another 1% to donate to good causes`
    },
    refferTooltip () {
      return `To split a ${this.getReward} bonus of the jobs pay if your referral for this job is hired`
    },
    isCompleted () {
      return this.job.status === 'completed'
    },
    hiredCount () {
      return this.job.hiredCount ? this.job.hiredCount : 0
    },
    tooltip () {
      let type = ''
      let date = ''
      switch (this.job.applicationStatus) {
        case 'offered':
          if (this.currentOffer !== null) {
            type = 'Offered: '
            date = this.formatDate(this.currentOffer.createdAt)
          }
          break
        case 'applied':
          if (this.currentApplication !== null) {
            type = 'Applied: '
            date = this.formatDate(this.currentApplication.createdAt)
          }
          break
        default:
          type = ''
          date = ''
          break
      }
      return type + date
    },
    jobViews () {
      return this.job.views
    }
  },
  mounted () {
    this.setFormSubmit(false)
    this.resetWidgetJobForm()
    this.setSelectedJobId(this.$route.params.id)
    this.percentage = RewardHelper.calcShare(this.job.rewardPercentage)
  },
  data: function () {
    return {
      tooltipActive: false,
      percentage: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.card {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
}

.is-primary.is-inverted {
  border-color: $primary;
}

.field:not(:last-child) {
  margin-bottom: 1rem;
}

.is-ghost {
  padding: 1rem;
}

.is-white{
  padding: 1rem;
}

.title {
  margin-bottom: 0;
  line-height: normal;
  margin-bottom: 0.75rem;
}

.title.subtitle {
  margin-top: 0;
  line-height: normal;
  margin-bottom: 0rem;
}

.subtitle.title {
  letter-spacing: 2px;
  font-weight: 900;
}

.button {
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
}

.button.is-primary.is-inverted:hover {
  background-color: rgba(62,207,142,.025)
}
.is-completed {
  width: 100%;
  height: 100%;
  background: rgba(255,255,255, 0.3);
  position: absolute;
  top: 0;
  left: 0;
  cursor: not-allowed;
  z-index: 1;
}

.rl-radius{
  border-top-left-radius: 4px; border-top-right-radius: 4px
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/job-action-card.vue